/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AppDownload from "./AppDownload";

export {
  AppDownload
};
